<template>
  <div>
    <div data-cy="form-label" class="b-dialog__top-panel mb-4">
      <h2>{{$t('CONTENT.assets.assetComponent_editing')}}</h2>
      <button class="b-btn b-btn_border_none" @click="closeEditAssetComponentPopup">
        <dynamic-icon icon="close" />
      </button>
    </div>
    <form class="b-form b-dialog__form">
      <server-error :error="error" />
      <AssetComponentWithoutStore
        :contract="contract"
        :assetComponent="formData"
        :unitsOfMeasure="unitsOfMeasure"
        :validationErrors="validationErrors"
        :isSimplifiedAssetComponent="isSimplifiedAssetComponent"/>
      <div class="row mt-4">
        <div class="col-6 offset-6">
          <div class="b-form__container b-form__container_type_flex b-form__container_type_flex_end">
            <button
              data-cy="save-button"
              class="b-btn b-btn_type_primary"
              type="submit"
              @click.prevent="onSubmit">
                {{$t('CONTENT.save')}}
            </button>
            <button
              class="b-btn b-btn_type_empty m-2"
              @click.prevent="closeEditAssetComponentPopup">
                {{$t('CONTENT.cancel')}}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import ExtensionOption from "../../../../../models/contract/ExtensionOption";
  import TerminationOption from "../../../../../models/contract/TerminationOption";
  import BuyoutOption from "../../../../../models/contract/BuyoutOption";

  export default {
    props: {
      assetComponent: {
        type: Object,
      },
      isSimplifiedAssetComponent: {
        type: Boolean,
      },
      contract: {
        type: Object,
  }
    },
    data() {
      return {
        error: null,
        formData: {},
        validationErrors: []
      };
    },
    created() {
      this.updateFormData();
    },
    computed: {
      ...mapGetters(["getUnitOfMeasure"]),
      unitsOfMeasure() {
        return this.getUnitOfMeasure;
      },
    },
    methods: {
      updateFormData() {
        this.formData = _.cloneDeep(this.assetComponent);
      },
      closeEditAssetComponentPopup() {
        this.$emit("close");
        this.formData = _.cloneDeep(this.assetComponent);
      },
      async onSubmit(e) {
        e.preventDefault();
        if (!this.validate()) return;
        let currentAssetComponent = null;
        currentAssetComponent = _.cloneDeep(this.formData);

        if(currentAssetComponent.extension !== null && !currentAssetComponent.extension.isExtension) {
          currentAssetComponent.extension = null;
        } else {
          currentAssetComponent.extension = ExtensionOption.createFromData(currentAssetComponent.extension);
        }

        if(currentAssetComponent.termination !== null && !currentAssetComponent.termination.isTermination) {
          currentAssetComponent.termination = null;
        } else {
          currentAssetComponent.termination = TerminationOption.createFromData(currentAssetComponent.termination);
        }

        if(currentAssetComponent.buyout !== null && !currentAssetComponent.buyout.isBuyout) {
          currentAssetComponent.buyout = null;
        } else {
          currentAssetComponent.buyout = BuyoutOption.createFromData(currentAssetComponent.buyout);
        }

        this.$eventBus.$emit('saveAssetComponentEditing', currentAssetComponent);
        this.$emit("close");
        this.formData = _.cloneDeep(this.assetComponent);
      },
      validate() {
        let currentAssetComponent = _.cloneDeep(this.formData);
        this.validationErrors = [];
        if (currentAssetComponent.quantity === null || currentAssetComponent.quantity === undefined) {
          this.validationErrors.push("quantity");
        }
        if (!currentAssetComponent.unitOfMeasureCode) {
          this.validationErrors.push("unitOfMeasureCode");
        }
        if (!currentAssetComponent.endDate) {
          this.validationErrors.push("endDate");
        }
        if (!currentAssetComponent.startDate) {
          this.validationErrors.push("startDate");
        }
        return this.validationErrors.length <= 0;
      }
    }
  };
</script>
